import { ServiceWorkerAbsenceType } from '@navio/nsdk';
import { NoddiIcon, type NoddiIconName } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { SERVICE_WORKER_ABSENCE_TYPE_LABEL_BY_VALUE } from 'noddi-util';

// A leading icon per type so the badge still reads at a glance now that it carries
// no color. Exhaustive map — adding a new ServiceWorkerAbsenceType fails the build
// until it gets an icon here.
const ABSENCE_TYPE_ICON: Record<ServiceWorkerAbsenceType, NoddiIconName> = {
  [ServiceWorkerAbsenceType.VACATION]: 'TreePalm',
  [ServiceWorkerAbsenceType.SICK]: 'Thermometer',
  [ServiceWorkerAbsenceType.SICK_CHILD]: 'Baby',
  [ServiceWorkerAbsenceType.DOCTOR]: 'Stethoscope',
  [ServiceWorkerAbsenceType.DENTIST]: 'Smile',
  [ServiceWorkerAbsenceType.PERSONAL]: 'User',
  [ServiceWorkerAbsenceType.COMPASSIONATE]: 'Handshake',
  [ServiceWorkerAbsenceType.PARENTAL_LEAVE]: 'Heart'
};

interface Props {
  type: ServiceWorkerAbsenceType;
  // Optional trailing day count, rendered inside the same badge (overview cards).
  count?: number;
  className?: string;
}

// Plain outline badge with a per-type icon — the same neutral chrome for every
// absence type. Type is descriptive, not a status, so it deliberately carries no
// color: a table row's single colored chip is its status (see AbsenceStatusBadge).
export const AbsenceTypeBadge = ({ type, count, className }: Props) => (
  <NoddiBadge variant='outline' className={className}>
    <NoddiIcon name={ABSENCE_TYPE_ICON[type]} size='xSmall' />
    {SERVICE_WORKER_ABSENCE_TYPE_LABEL_BY_VALUE[type]}
    {count !== undefined && (
      <>
        <span className='opacity-50'>·</span>
        <span className='font-semibold tabular-nums'>
          {count} {count === 1 ? 'day' : 'days'}
        </span>
      </>
    )}
  </NoddiBadge>
);
